<template>
  <div class="row">
    <div class="col-12 col-md-11 col-lg-8 offset-md-1 offset-lg-2">
      <p class="title center-sm">Mietrecht</p>
      <p class="mt-5">Auf dem Gebiet des Mietrechts berate und vertrete ich Vermieter und Mieter gleichermaßen.</p>
      <p class="mt-5">Üblicherweise wenden sich <b>Vermieter</b> an mich,</p>
      <ul class="margin-sm">
        <li>deren Mieter die Miete nicht zahlen,</li>
        <li>bei Problemen mit sog. "Mietnomaden",</li>
        <li>bei Streitigkeiten um Betriebskostenabrechnungen (Nebenkostenabrechnungen),</li>
        <li>wenn es Fragen über die Verwertung der Kaution gibt,</li>
        <li>wenn Mieter andere Mieter oder den Vermieter belästigen oder bedrohen,</li>
        <li>wenn Mieter die Wohnung beschädigt haben ober beschädigt zurückgeben, wenn eine Mieterhöhung oder Modernisierungsmieterhöhung beabsichtigt ist,</li>
        <li>wenn das Mietverhältnis gekündigt werden soll, auch bei beabsichtigten Kündigungen wegen Eigenbedarf,</li>
        <li>bei Fragen zur Untervermietung oder</li>
        <li>bei Fragen zur Tierhaltung.</li>
      </ul>
      <p class="mt-5">Üblicherweise wenden sich <b>Mieter</b> an mich,</p>
      <ul class=" margin-sm">
        <li>wenn Schimmel in der Wohnung vom Vermieter nicht entfernt wird oder andere Mängel nicht behoben werden,</li>
        <li>wenn sie von anderen Mietern durch Lärm oder andere Belästigungen gestört werden,</li>
        <li>wenn eine Mieterhöhung geprüft werden soll,</li>
        <li>bei Fragen zur Betriebskostenabrechnung (Nebenkostenabrechnung),</li>
        <li>wenn die Kaution nicht zurückgegeben wird,</li>
        <li>bei Kündigungen durch den Vermieter, auch wegen Eigenbedarf,</li>
        <li>wenn eine vom Vermieter angebotene Vertragsänderung geprüft werden soll,</li>
        <li>wenn eine weitere Person in die Wohnung einziehen soll,</li>
        <li>bei Fragen zur Untervermietung oder</li>
        <li>bei Fragen zur Tierhaltung.</li>
      </ul>
    </div>
    <div class="col-12 col-md-8 col-lg-8 offset-md-1 offset-lg-2 mt-5">
      <p class="center-sm">Weitere Schwerpunkte:</p>
      <ul class="fields-of-law margin-sm">
        <li><a @click.prevent="$emit('routeTo', 'fl')" href="#">Familienrecht</a></li>
        <li><a @click.prevent="$emit('routeTo', 'cl')" href="#">Strafrecht</a></li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "LawOfTenancy.vue"
}
</script>

<style scoped>

</style>